import React from 'react';
import { X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button
} from '@mui/material';

const ResponseViewerModal = ({ open, onClose, response }) => {
  if (!open || !response) return null;

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
    >
      <DialogTitle className="flex justify-between items-center">
        <div>
          <Typography variant="h6">{response.form_title}</Typography>
          <Typography variant="body2" color="textSecondary">
            Submitted: {formatDate(response.submitted_at)}
          </Typography>
        </div>
        <IconButton onClick={onClose} size="small">
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} className="mb-4">
          <Table>
            <TableBody>
              {(response.responses || []).map((item, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row" className="font-medium">
                    {item.question_text || 'Question'}
                  </TableCell>
                  <TableCell>{item.response || 'No response'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box className="flex justify-end gap-2 mt-4">
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ResponseViewerModal;
